import { IconNameV1 } from 'common/icon/iconV1.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { getSeverityInfo } from './warning-severity.js';

export function findHighestRankedHighSeasIcon(warnings: IWarning[]): IconNameV1 | undefined {
  if (warnings.length) {
    // Priority order - Cyclone > storm > gale > ice accretion
    const isCyclone = warnings.find(({ icon }) => icon.includes('cyclone'));

    if (isCyclone) {
      const info = getSeverityInfo(isCyclone.warnLevel);

      return `${isCyclone.icon}-${info.iconColor}` as IconNameV1;
    }

    const iStorm = warnings.find(({ icon }) => icon.includes('storm'));

    if (iStorm) {
      const info = getSeverityInfo(iStorm.warnLevel);

      return `${iStorm.icon}-${info.iconColor}` as IconNameV1;
    }

    const isGale = warnings.find(({ icon }) => icon.includes('gale'));

    if (isGale) {
      const info = getSeverityInfo(isGale.warnLevel);

      return `${isGale.icon}-${info.iconColor}` as IconNameV1;
    }

    const isIce = warnings.find(({ icon }) => icon.includes('iceaccretion'));

    if (isIce) {
      const info = getSeverityInfo(isIce.warnLevel);

      return `${isIce.icon}-${info.iconColor}` as IconNameV1;
    }
  }

  return undefined;
}
